<template>
  <section class="hero-app-showcase bg-cover" :style="bgImg" id="home">
    <div class="hero-item text-center">
      <div class="hero-content" v-if="content">
        <h2 class="h1 hero-content-title font-weight-light">{{ content.data.title }}</h2>
        <div class="mt-30">
          <h5 class="h4 hero-content-title font-weight-light">{{ content.data.subtitle }}</h5>
        </div>
      </div>
    </div>
    <div class="vc_row-separator center_curve_alt bottom">
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="none" viewBox="0 0 100 100">
        <path d="M 0 0 L0 100 L100 100 L100 0 Q 50 200 0 0"></path>
      </svg>
    </div>
  </section>
</template>

<script>

export default {
  computed: {
    content() {
      return this.$store.getters["app/content"]('521ed0b9-c3a4-4619-9b80-bfc5dcd6787a')
    }
  },
  data() {
    return {
      bgImg: {
        backgroundImage: `url("https://con1.artatolstatic.com/image/1800/a44c239d-6af5-4d76-9dd9-2c9ca287f69f.jpg")`
      },
    }
  },
}
</script>